import { Label } from '@/components/ui/label';
import useLogin from './uesLogin';
import { Input } from '@/components/ui/input';
import Button from '@/components/Button';
import { Link } from 'react-router-dom';
import Container from '@/components/Container';
import FieldError from '@/components/FieldError';
import { Suspense } from 'react';
import Loading from './loading.skeleton';

function LoginComponent() {
  const { handleSubmit, register, loginPage, isConfirmation, errors, isLoading } = useLogin();

  const renderHeaderMessages = () => {
    if (isConfirmation) {
      return (
        <>
          <p className=" mb-2 font-cadiz text-sh-md font-bold">{loginPage?.confirmEmailTitle}</p>{' '}
          <p className=" mb-8 font-cadiz text-sh-sm">{loginPage?.pleaseLoginTItle}</p>
        </>
      );
    }

    return (
      <h2 className="mb-sh-15 text-center font-cadiz text-sh-28-32 font-bold leading-9 tracking-tight text-gray-900">
        {loginPage?.loginTitle}
      </h2>
    );
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Container className="h-full">
      <div className="col-span-12 flex items-center justify-center">
        <div className="flex max-h-[90vh] w-full max-w-[430px] flex-col items-start overflow-auto rounded-2xl bg-white p-8 shadow-light-purple">
          <img
            className="mb-16 w-[265px]  self-center"
            src={loginPage?.pageImage.data?.attributes?.url}
            alt={loginPage?.pageImage.data?.attributes?.alternativeText || 'Logo'}
          />
          {renderHeaderMessages()}

          <form className="flex w-full flex-col items-start" onSubmit={handleSubmit}>
            <div className="mb-5 w-full">
              <Label>
                <p className="mb-2 font-cadiz text-sh-xs text-gray-900">{loginPage?.yourEmailTitle}</p>
              </Label>
              <Input placeholder={loginPage?.yourEmailTitle} type="email" {...register('identifier')} />
              <FieldError message={errors?.identifier?.message} />
            </div>

            <div className="mb-9 w-full">
              <Label>
                <p className="mb-2 font-cadiz text-sh-xs text-gray-900">{loginPage?.yourPasswordTitle}</p>
              </Label>
              <Input placeholder={loginPage?.yourPasswordTitle} type="password" {...register('password')} />
              <FieldError message={errors?.password?.message} />
            </div>

            <Button type="submit" theme="solid" className=" mb-4">
              {loginPage?.loginCta}
            </Button>
          </form>
          <Link className="text-center font-cadiz text-sh-xxs underline" to="/reset-password">
            {loginPage?.forgotYourPasswordCta}
          </Link>

          <p className="mt-4 font-cadiz text-sh-xxs font-normal">
            Don&apos;t have a login?{'  '}
            <Link className="text-center underline" to="/register">
              Register here
            </Link>
          </p>
        </div>
      </div>
    </Container>
  );
}

export default function Login() {
  return (
    <Suspense fallback={<Loading />}>
      <LoginComponent />
    </Suspense>
  );
}
